import { Dispatch } from "react";
import { RbiAction } from "../reducer";
import { WelderState } from "../types";

type WeldSelectionFiltersProps = {
  state: WelderState;
  updateState: Dispatch<RbiAction>;
};

export function WeldSelectionFilters({ state, updateState }: WeldSelectionFiltersProps) {
  function handleFilterChanged(e: React.FormEvent<HTMLInputElement>) {
    updateState({
      type: "Filters",
      payload: { ...state.filters, [e.currentTarget.id]: e.currentTarget.checked },
    });
  }

  return (
    <div className="mt-2">
      {/* <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="onlyMyWelds"
          checked={state.filters.onlyMyWelds}
          onChange={handleFilterChanged}
        />
        <label className="form-check-label" htmlFor="onlyMyWelds">
          Only welds assigned to me
        </label>
      </div> */}

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="onlyRepairOrRewelds"
          checked={state.filters.onlyRepairOrRewelds}
          onChange={handleFilterChanged}
        />
        <label className="form-check-label" htmlFor="onlyRepairOrRewelds">
          Only repair/re-welds
        </label>
      </div>
    </div>
  );
}
